/*
 * @Description: 高级搜索使用的下拉框
 * @Author: zengweijin
 * @Date: 2019-09-11 10:34:17
 * @LastEditors: zengweijin
 * @LastEditTime: 2019-09-16 18:01:38
 */
import React from "react";
import { Select } from 'antd';
import PropTypes from 'prop-types';
import NHFetch from "../../../utils/NHFetch";
/**
 * value和label值都是一样的下拉框
 * 支持本地数据、sign，代码标志（DMK_DMBZ）
 * 除了特有属性，其他同antd Select
 */
const Option = Select.Option;
class HighSelect extends React.Component {

    static getDerivedStateFromProps(nextProps) {

        let updateState = {};
        if ('dataSource' in nextProps) {
            const data = nextProps.dataSource;
            Object.assign(updateState, { data });
        }

        if(Object.keys(updateState).length > 0) {
            return updateState;
        }

        return null;
    }

    constructor(props) {
        super(props)
        this.state = {
            data: [],
        }
    }

    componentDidMount() {

        const { sign } = this.props;

        //如果是使用数据源标识，则优先加载远程数据
        if (sign && sign != '') {
            this.loadRemoteData(sign);
        } else {
            //如果没有使用远程数据，则加载本地数据
            this.loadLocalData();
        }
    }
    //加载远程数据
    loadRemoteData = (sign) => {
        const baseUrl = this.props.baseUrl;
        NHFetch((baseUrl === undefined ? "" : baseUrl) + "/proData/selectDataList", 'GET', { sign: sign,t:new Date().getTime() })
            .then(res => {
                if (res) {
                    this.parseData(res.data);
                }
            });
    }

    //加载本地数据
    loadLocalData = () => {
        if (this.props.dataSource) {
            this.setState({ data: [...this.props.dataSource] });
        }
    }

    //解析数据
    parseData = (data) => {
        if (data) {
            this.setState({ data: [...data] });
        } else {
            //如果远程数据为空，则尝试加载本地数据源
            this.loadLocalData();
        }
    }
    render() {
        const { filterData, ...otherprops } = this.props;
        const { data } = this.state;
        let options = [];

        //如果有过滤条件
        if (filterData) {

            const { type, filterkeys = [] } = filterData;
            switch (type) {
                //过滤掉指定key值
                case 'remove': {
                    const newData = data.filter(item => {
                        if (filterkeys.find((key) => (item.VALUE || item.value) == key)) {
                            return false;
                        } else {
                            return true;
                        }
                    });
                    options = newData.map(option => <Option key={option.VALUE || option.value} value={option.LABEL || option.label}>{option.LABEL || option.label}</Option>);
                    break;
                }
                //保留指定key值
                case 'save': {
                    const newData = data.filter(item => {
                        if (filterkeys.find((key) => (item.VALUE || item.value) == key)) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    options = newData.map(option => <Option key={option.VALUE || option.value} value={option.LABEL || option.label}>{option.LABEL || option.label}</Option>);
                    break;
                }
                //未找到指定过滤类型，则不做过滤
                default: {
                    options = data.map(option => <Option key={option.VALUE || option.value} value={option.LABEL || option.label}>{option.LABEL || option.label}</Option>);
                    break;
                }
            }

        } else {

            options = data.map(option => <Option key={option.VALUE || option.value} value={option.LABEL || option.label}>{option.LABEL || option.label}</Option>);

        }

        return (
            <div>
                <Select
                    {...otherprops}
                    showSearch
                    notFoundContent={"无数据"}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    {options}
                </Select>
            </div>
        )
    }
}

//属性默认值
HighSelect.defaultProps = {
    placeholder: '请选择...',
    disabled: false
}

//属性检查
HighSelect.propTypes = {
    sign: PropTypes.string, //远程数据源标识
    dataSource: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.node
        })
    ), //本地数据源
    // style: PropTypes.object, //样式
    // placeholder: PropTypes.string, //下拉提示
    // disabled: PropTypes.bool, //是否禁用
    // defaultValue: PropTypes.oneOf([PropTypes.string,PropTypes.arrayOf(PropTypes.string)]), //默认值
    // value: PropTypes.oneOf([PropTypes.string,PropTypes.arrayOf(PropTypes.string)]), //初始值
    filterData: PropTypes.shape({
        type: PropTypes.oneOf(['remove', 'save']), //是保留还是过滤掉
        filterkeys: PropTypes.array //保留或过滤的key值
    }), //要过滤掉的Key值
    // onSelect: PropTypes.func,//下拉选项选中时回调
    // onChange: PropTypes.func,//下拉框值变化时回调
    baseUrl: PropTypes.string,//请求路径的前缀，可通过改参数控制访问的后端服务，如果不设置，则会去访问当前前端服务对应的后端服务，例如：api/sm-bpm-expansion
}


export default HighSelect;


// WEBPACK FOOTER //
// ./components/tjcx/hjblcx/highSelect.js